import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { Table }         from '../table/types/table';
import { TableRowEvent } from '../table/types/table-row-event';

@Component({
  selector: 'wor-branch-linked-companies-lookup',
  template: `
    <div class="modal-header state clearfix bg-info title">
      <h1>Branch Companies</h1>
    </div>
    <div class="modal-body clearfix">
      <wor-table
        [(data)]="companies"
        [settings]="tableSettings"
        (rowClick)="onRowClick()"
        (rowDoubleClick)="onRowDoubleClick($event)">
      </wor-table>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-danger m-left-auto"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button type="button" class="btn btn-success"
        [disabled]="!selectedItems.length"
        (click)="confirm()">
        Confirm
      </button>
    </div>
  `
})
export class BranchLinkedCompaniesLookupComponent implements OnInit {
  @Input() companies: any[] = [];

  selectedItems: any[] = [];
  tableSettings: Table;

  constructor (
    public  modal           : NgbActiveModal,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          classes: 'text-left',
          field  : 'store_name',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_COMPANIES')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      }
    };
  }

  onRowClick (): void {
    this.selectedItems = this.companies.filter(row => row.selected);
  }

  onRowDoubleClick (event: TableRowEvent): void {
    this.modal.close(event.row);
  }

  confirm (): void {
    this.modal.close(this.selectedItems[0]);
  }
}
